/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if ((typeof Shopify) === 'undefined') { window.Shopify = {}; }
  // Get from cart.js returns the cart in JSON
  if ((typeof Shopify.getCart) === 'undefined') {
  Shopify.getCart = function(callback, cart) {
    if(!cart){
    return jQuery.getJSON('/cart.js', function (cart, textStatus, xhr) {
        if ((typeof callback) === 'function') {
        callback(cart,textStatus, xhr);
      }
      else {
        Shopify.onCartUpdate(cart);
          }
      });
    }else{
      if ((typeof callback) === 'function') {
      callback(cart);
    }else if(typeof Shopify.onCartUpdate ==='function') {
      Shopify.onCartUpdate(cart);
        }
    }
  };
}

$(document).ready(function(){


$('.swatch-element').click(function(){
 var curpath=$(this).attr('data-img'); 
  console.log(curpath) ;
$('.Product__SlideItem').removeClass('is-selected');
$('.Product__SlideItem').addClass('Item--hidden');

$(".Product__Slideshow img").each(function(){
    var needpaths=$(this).attr('data-original-src');
 console.log(needpaths);

  if (needpaths.indexOf(curpath) >= 0)
  {
        $(this).parent().parent().addClass('is-selected');
        $(this).parent().parent().removeClass('Item--hidden');

  }

  });

}); 

// 	$('.ad_to_cart_coll').click(function(){    
//   var ID = $(this).attr("data-var_id");
//   addItemToCart( ID, 1);    // paste your id product number
//   $('.cart_dr').trigger( "click" );
// });
// function addItemToCart(variant_id, qty) {
//   data = {
//     "id": variant_id,
//     "quantity": qty
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function() { 
//       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
//         bubbles: true  //this code is for prestige theme, is to refresh the cart
//       }));
//     }   
    
//   }); 
 
// }
	$('ul.tabs li').click(function(){
$('.tab-content').hide();
		var tab_id = $(this).attr('data-tab');

		$('ul.tabs li').removeClass('current');
		$('.tab-content').removeClass('current');

		$(this).addClass('current');
		$("#"+tab_id).addClass('current');
$('.tab-content.current').show();
	})


$('.meta-image').slick({
 
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
   nav:true
});


 $('.AnnouncementBar__Wrapper').slick({
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
   
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }

    }, {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
 
      }
    },  {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1 
      }
    }]
  });

   $('.custom_team:not(.testimonials_v2) .teamslider').slick({
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
     nav:false,
    autoplaySpeed: 2000,
   
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }

    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
 
      }
    },  {
      breakpoint: 480,
      settings: {
         nav:true,
       autoplay: false,
        slidesToShow: 2,
        slidesToScroll: 2 
      }
    }]
  });

   $('.custom_team.testimonials_v2 .teamslider').slick({
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
     nav:false,
    autoplaySpeed: 2000,
   
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }

    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
 
      }
    },  {
      breakpoint: 480,
      settings: {
        nav:true,
       autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 2 
      }
    }]
  });

  $(".section-image-text-v2 .FeatureText__ImageWrapper").slick({
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1, 
     nav:true, 
    autoplaySpeed: 2000,
   
    responsive: [{
      breakpoint: 480,
      settings: { 
       autoplay: false,
        slidesToShow: 1,
        slidesToScroll:1 
      }
    }]
  }); 
if($(window).width() <= 767){
 // $(".Section.Section--spacingNormal .ProductList.ProductList--grid").slick({
 //    speed: 500,
 //    slidesToShow: 2,
 //    slidesToScroll: 1, 
 //     nav:true, 
 //    autoplaySpeed: 2000,
   
 //    responsive: [{
 //      breakpoint: 480,
 //      settings: { 
 //       autoplay: false,
 //        slidesToShow: 2,
 //        slidesToScroll: 2 
 //      }
 //    }]
 //  }); 
  
  $("[data-section-type='article-list'] .ArticleList").slick({
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1, 
     nav:true,
    autoplaySpeed: 2000,
   
    responsive: [{
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }

    }, {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
 
      }
    },  {
      breakpoint: 480,
      settings: {
       autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1 
      }
    }]
  }); 
  $('.owl-carousel.deskslider').owlCarousel({
   slideTransition: 'linear',
autoplayTimeout : 4000,
autoplayHoverPause : false,
autoplaySpeed :4000,
    margin:10,
    loop:true,
    nav:true,
    responsive:{
        0:{
            items:3,
             nav:true,
            dots:false
        },
        767:{
            items:3,
             nav:false
        }

    }
})
}

$('.owl-carousel.blockslider').owlCarousel({
  loop:true,
    margin:10,
    nav:true,
    responsive:{
        0:{
            items:2,
             nav:true
        },
        767:{
            items:3,
             nav:true
        },
        1000:{
            items:5
        }
    }
})


$('.product-slider').slick({
  arrows: true,
  dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
slidesToScroll: 1
     
  
});

 $('.Marquee-content').slick({
    speed: 5000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: true,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false
  });


$('.tab-content').hide();
$('.tab-content.current').show();



$(document).ready(function(){
  $(".modal-link-a.ingredient-link").click(function(){
    $("body").addClass("ingredient-active");
    return false;
  });
  $("#ingredient-modal-sec .close-btn").click(function(){
    jQuery("body").removeClass("ingredient-active");
  });
  $(".modal-link-a.none-link").click(function(){
    jQuery("body").addClass("none-active");
    return false;
  });
  $("#non-modal-sec .close-btn").click(function(){
    $("body").removeClass("none-active");
  });
    $(".modal-link-a.disclaimer").click(function(){
    $("body").addClass("disclaimer-active");
    return false;
  });
  $("#disclaimer-modal-sec .close-btn").click(function(){
    $("body").removeClass("disclaimer-active");
  });
  $(".modal-link-a.covid-note").click(function(){
    $("body").addClass("covid-active");
    return false;
  });
  $("#covid-note .close-btn").click(function(){
    $("body").removeClass("covid-active");
  });
});
 

    $('.gs-header').on('click',function(){
      if($(window).width()<=749){
        var act = $(this).attr('aria-expanded');
        console.log('Expanded '+act);
        if(act == 'false'){
          $(this).addClass('active');
          $(this).next('.gs-content').slideDown();
          console.log('open');
          $(this).attr('aria-expanded','true');
        }
        if(act == 'true'){
         $(this).removeClass('active');
          $(this).next('.gs-content').slideUp();
          console.log('close');
          $(this).attr('aria-expanded','false');
        }
      }
    });

})

// custom_theme.sidecart = function(){
//   var cart;
//   var url = "/cart?view=ajax";
//   $.ajax({
//     url: url,
//     success: function(cartpage) {
//       $("#sidebar-cart").html("");;
//       $("#sidebar-cart").append(cartpage);
//       $("#sidebar-cart").attr("aria-hidden","false");
//     }
//   });
// };

function ajaxCart(form, button){
var data = form.serialize();
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function(line_item) {
    Shopify.getCart(function(cart) {  
	//custom_theme.sidecart();
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true
      }));
      setTimeout(function(){jQuery('.header-cart-btn').find('a')[0].click(); }, 1000);
      button.text(button.attr("data-text"));
     }); 
    },
    error: function(XMLHttpRequest, textStatus) {
      var error = JSON.parse((XMLHttpRequest.responseText)).description;
      var error_popup = $("<div id='quick-error'></div>");
      error_popup.html("");
      error_popup.append("<h6>" + error + "</h6>");
      alert(error_popup);
      button.text(button.attr("data-text"));
    }
  };
  jQuery.ajax(params);
}
 
function ajacCartForm(){
  //ajax cart
  $(document).on("submit", ".collection-form", function(e) {
    e.preventDefault();
    var $form = $(this);
    var button = $(".CollectionForm__AddToCart", $form);
    button.text(button.attr("data-process"));
    ajaxCart($form, button);
  });
};


$(document).ready(function(){
	ajacCartForm();
});
  